import { Component } from '@angular/core';

@Component({
  selector: 'app-user-preview',
  standalone: true,
  imports: [],
  templateUrl: './user-preview.component.html',
  styleUrl: './user-preview.component.sass'
})
export class UserPreviewComponent {

}
